module.exports = __webpack_public_path__ + "static/img/avatar.2d7a30e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = HfaK
// module chunks = 3